import React from "react";

const RESOURCES = [
    {
        num: "01",
        title: "Expert Blog",
        desc: "Regular updates on IT trends, cybersecurity tips, and cloud innovations to keep you informed and ahead of the curve.",
    },
    {
        num: "02",
        title: "Case Studies",
        desc: "Whitepapers showcasing real-world IT transformations and proven business results for clients like yours.",
    },
    {
        num: "03",
        title: "Learning Events",
        desc: "Webinars and workshops available in both English and Hebrew for continuous professional education.",
    },
];

const Resources: React.FC = () => (
    <section className="resources" id="resources">
        <div className="section-number">04</div>
        <div className="container">
            <span className="section-eyebrow">Knowledge Hub</span>
            <h2 className="section-title">Resources &amp; Insights</h2>

            <div className="resources-list">
                {RESOURCES.map(r => (
                    <div className="resource-item" key={r.num}>
                        <div className="resource-num">{r.num}</div>
                        <div className="resource-content">
                            <h3>{r.title}</h3>
                            <p>{r.desc}</p>
                        </div>
                        <div className="resource-arrow">→</div>
                    </div>
                ))}
            </div>

            <div className="newsletter-strip">
                <p>Subscribe for exclusive content, industry insights, and company updates delivered directly to your inbox.</p>
                <button className="btn-primary">Subscribe to Newsletter</button>
            </div>
        </div>
    </section>
);

export default Resources;
